(() => {
  const init = () => {
    const settings = document.querySelector("[data-ngr]");
    const speed = Math.min(120, Math.max(10, Number(settings?.dataset.motionSpeed) || 40));
    const reduced = matchMedia("(prefers-reduced-motion: reduce)");
    const hoverDevice = matchMedia("(hover: hover)");
    document.querySelectorAll(".section-featured-collection").forEach((section) => {
      const heading = section.querySelector("h2 a");
      if (!heading || !["/collections/new-arrivals", "/collections/featured-items"].includes(heading.getAttribute("href"))) return;
      const slider = section.querySelector(".collection-listing.slider");
      if (!slider || slider.dataset.noveContinuous) return;
      slider.dataset.noveContinuous = "true";
      let inView = false, holding = false, frame = 0, last = 0, direction = 1, holdUntil = 0;
      const stop = () => { cancelAnimationFrame(frame); frame = 0; last = 0; };
      const start = () => {
        if (!frame && inView && !reduced.matches && document.visibilityState === "visible") frame = requestAnimationFrame(tick);
      };
      const tick = () => {
        frame = 0;
        const time = Date.now();
        const interacting = section.contains(document.activeElement) || (hoverDevice.matches && section.matches(":hover"));
        if (!interacting && !holding && time >= holdUntil && last) {
          const end = Math.max(0, slider.scrollWidth - slider.clientWidth);
          if (end > 0) {
            slider.scrollLeft += direction * speed * Math.min(50, time - last) / 1000;
            if (slider.scrollLeft >= end - 1) { direction = -1; holdUntil = time + 1000; }
            else if (slider.scrollLeft <= 0) { direction = 1; holdUntil = time + 1000; }
          }
        }
        last = time;
        start();
      };
      const configure = () => {
        if (reduced.matches) {
          stop();
          slider.style.removeProperty("scroll-snap-type");
          slider.style.removeProperty("scroll-behavior");
        } else {
          slider.style.scrollSnapType = "none";
          slider.style.scrollBehavior = "auto";
          start();
        }
      };
      section.addEventListener("mouseleave", () => { last = 0; start(); });
      section.addEventListener("focusout", () => { last = 0; start(); });
      section.addEventListener("pointerdown", () => { holding = true; });
      window.addEventListener("pointerup", () => { if (holding) { holding = false; holdUntil = Date.now() + 1500; last = 0; start(); } });
      section.addEventListener("pointercancel", () => { holding = false; holdUntil = Date.now() + 1500; start(); });
      section.addEventListener("wheel", () => { holdUntil = Date.now() + 1500; }, { passive: true });
      section.querySelectorAll(".slider-nav button").forEach((button) => button.addEventListener("click", () => { holdUntil = Date.now() + 2000; }));
      new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
        inView ? start() : stop();
      }, { rootMargin: "180px" }).observe(section);
      document.addEventListener("visibilitychange", () => { document.visibilityState === "visible" ? start() : stop(); });
      reduced.addEventListener?.("change", configure);
      configure();
    });
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init, { once: true }) : init();
})();
